import { render } from "./Forward.vue?vue&type=template&id=23a6424f"
import script from "./Forward.vue?vue&type=script&lang=js"
export * from "./Forward.vue?vue&type=script&lang=js"
script.render = render

export default script